const BASE_URL = "https://zakariabalali.nl/api";

/**
 * Fetches word data from the Darija API.
 * Always returns a flat array of word objects.
 *
 * @param {string} endpoint - e.g. "adjectives", "nouns", "verbs"
 * @returns {Promise<Array>} Flat list of word objects
 * @throws {Error} When the network request fails or returns a non-OK status
 */
export async function fetchWords(endpoint) {
    const response = await fetch(`${BASE_URL}/${endpoint}`);

    if (!response.ok) {
        throw new Error(`API-fout: ${response.status} ${response.statusText}`);
    }

    const raw = await response.json();

    // Some endpoints return an object with category keys, others return a flat array
    return Array.isArray(raw) ? raw : Object.values(raw).flat();
}

/**
 * Fetches categorised word data (e.g. nouns grouped by category).
 * Returns the raw object so the caller can work with categories.
 *
 * @param {string} endpoint
 * @returns {Promise<Object>} Category map: { categoryName: wordArray[] }
 */
export async function fetchWordsByCategory(endpoint) {
    const response = await fetch(`${BASE_URL}/${endpoint}`);

    if (!response.ok) {
        throw new Error(`API-fout: ${response.status} ${response.statusText}`);
    }

    const raw = await response.json();

    if (typeof raw !== "object" || Array.isArray(raw)) {
        throw new Error(`Onverwacht antwoordformaat van /${endpoint}`);
    }

    return raw;
}
